import { render, staticRenderFns } from "./Contactd.vue?vue&type=template&id=490ca273&"
import script from "./Contactd.vue?vue&type=script&lang=js&"
export * from "./Contactd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports